/**
 * Build a clean URL from filter values.
 *
 * /near-me/                         → no filters
 * /near-me/texas/                   → state
 * /near-me/texas/austin/            → state + city
 * /near-me/texas/page/2/            → state + pagination
 * /near-me/texas/austin/page/2/     → state + city + pagination
 * /near-me/?ba_search=x&ba_zip=y    → search/zip as query params
 */
function buildCleanUrl(basePath, filters) {
  var path = basePath;

  if (filters.state) path += "/" + filters.state;
  if (filters.city) path += "/" + filters.city;
  if (filters.page > 1) path += "/page/" + filters.page;

  path += "/";

  var params = [];
  if (filters.search) params.push("ba_search=" + encodeURIComponent(filters.search));
  if (filters.zip) params.push("ba_zip=" + encodeURIComponent(filters.zip));

  // Preserve the new_profile toggle from the current URL.
  if (new URLSearchParams(window.location.search).has("new_profile")) {
    params.push("new_profile=1");
  }

  if (params.length) path += "?" + params.join("&");

  return path;
}

/**
 * Parse the current URL back into filter values.
 */
function parseCleanUrl(basePath) {
  var path = window.location.pathname;
  var params = new URLSearchParams(window.location.search);

  // Strip base path and trailing slash, split into segments.
  var escapedBase = basePath.replace(/\//g, "\\/");
  var rel = path.replace(new RegExp("^" + escapedBase + "\\/?"), "");
  rel = rel.replace(/\/$/, "");
  var segments = rel ? rel.split("/") : [];

  var state = "";
  var city = "";
  var page = 1;

  var i = 0;
  while (i < segments.length) {
    if (segments[i] === "page" && segments[i + 1]) {
      page = parseInt(segments[i + 1]) || 1;
      i += 2;
    } else if (!state) {
      state = segments[i];
      i++;
    } else if (!city) {
      city = segments[i];
      i++;
    } else {
      i++;
    }
  }

  return {
    state: state,
    city: city,
    search: params.get("ba_search") || "",
    zip: params.get("ba_zip") || "",
    page: page,
  };
}

export { buildCleanUrl, parseCleanUrl };
